import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const FiltersWrapper = styled.div`
  height: 60px;
  width: 1100px;
  padding: 5px 0;
  display: flex;
  position: fixed;
  top: 117px;
  background-color: #e4e5e7;
  align-items: center;
  z-index: ${(props) => (props.mobileFilterActive ? "6" : "2")};
  transition: 0.2s ease-in-out;

  &.animated.delay-1 {
    animation-delay: 0.15s;
  }

  ${mediaMaxWidth.mediumDesktop`
    width: 650px;
    margin: 0 auto;
    left: 60px;
    right: 0;
  `}

  ${mediaMaxWidth.tablet`
    left: 0;
    height: ${(props) =>
      props.datePickerActive
        ? "80px"
        : "40px"}; // change this rule to "height: 80px;" when company filter is added */
    flex-direction: column;
    width: 100vw;

    &.downScroll {
      top: ${(props) => !props.datePickerActive && "56px"};
      animation-delay: ${(props) => !props.datePickerActive && "0s"};
    }

    top: ${(props) => props.datePickerActive && "0"};
  `}
`;

export const Wrapper = styled.div`
  height: 60px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  position: absolute;
  /* left: ${(props) =>
    props.date && "410px"}; - uncomment this when company filter is added */
  opacity: ${(props) =>
    props.isPremiumOrPortalUser || props.hubAdminPresent ? "1" : "0.5"};
  filter: ${(props) =>
    !props.isPremiumOrPortalUser &&
    !props.hubAdminPresent &&
    "blur(2px) grayscale(100%)"};

  ${mediaMaxWidth.mediumDesktop`
    margin: 0;
    // left: ${(props) =>
      props.date && "320px"}; - uncomment this when company filter is added */
  `}

  ${mediaMaxWidth.tablet`
    top: ${(props) => !props.date && "-5px"};
    top: ${(props) => props.date && props.datePickerActive && "33px"};
    // top: ${(props) =>
      props.date &&
      !props.datePickerActive &&
      "40px"}; - uncomment this when company filter is added
    margin: ${(props) => props.date && "0 auto"};
    left: ${(props) => props.date && "0"};
    right: ${(props) => props.date && "0"};
    width: ${(props) => props.date && "270px"};
    height: ${(props) => props.date && "30px"};
  `}
`;

export const Filter = styled.div`
  position: relative;
  margin-top: 4px;
  color: #333;
  display: flex;
  align-items: center;

  .fa-calendar {
    position: relative;
    top: -2px;
    color: #565656;
  }
`;

export const DatePickerWrapper = styled.div`
  border-radius: 4px;

  .DateRangePicker {
    tr td:first-child {
      min-width: unset;
    }

    .DateRangePickerInput {
      padding: 0 5px;
      height: 24px;
      background-color: #e8e5ee;
    }

    .DateInput {
      height: 22px;
      width: 115px;
    }

    .DateInput_input {
      background-color: #e8e5ee;
      height: 22px;
      padding: 0 0 0 0;
      font-size: 0.92em;
      border-bottom: none;
      font-weight: 700;
      text-align: center;
      color: #565656;
      cursor: pointer;
      color: transparent;
      text-shadow: 0 0 0 #565656;

      &::-webkit-input-placeholder {
        color: #565656;
      }

      &:-ms-input-placeholder {
        color: #565656;
      }

      &::placeholder {
        color: #565656;
      }
    }

    .DateRangePicker_picker {
      top: 32px !important;
      border-radius: 4px;

      ${mediaMaxWidth.tablet`
        top: 70px !important
        left: 0px !important;
        position: fixed;
        border-radius: 0px;
        width: 100vw;
        height: 100vh;
      `}
    }

    .DateInput_fang {
      top: 21px !important;
    }

    .DayPicker {
      border-radius: 4px;
      overflow: hidden;

      ${mediaMaxWidth.tablet`
        border-radius: 0;
        box-shadow: none;
      `}
    }

    .DayPickerNavigation_button {
      .fa-chevron-circle-left {
        color: #f2008c;
        font-size: 1.5em;
        position: absolute;
        left: 20px;
        top: 20px;
      }

      .fa-chevron-circle-right {
        color: #f2008c;
        font-size: 1.5em;
        position: absolute;
        right: 20px;
        top: 20px;
      }
    }

    .DayPicker_weekHeader {
      top: 56px;

      ${mediaMaxWidth.tablet`
        top: 45px;
      `}
    }

    .CalendarMonth_caption {
      font-size: 0.94em;

      ${mediaMaxWidth.tablet`
        padding-bottom: 21px;
      `}
    }

    .CalendarDay__default:hover {
      background: #8364b9;
      border: 1px double #fff;
      color: #fff;
    }

    .CalendarDay__selected,
    .CalendarDay__selected:active,
    .CalendarDay__selected:hover {
      background: #673490;
      border: 1px double #fff;
    }

    .CalendarDay__hovered_span,
    .CalendarDay__hovered:hover {
      background: #8f65d8;
      border: 1px double #fff;
      color: #fff;
    }

    .CalendarDay__selected_span {
      background: #8364b9;
      border: 1px double #fff;
    }

    .DateRangePickerInput_clearDates {
      right: -30px;
      top: 11px;
      border-radius: 50%;
      height: 22px;
      width: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;

      svg {
        fill: #333;
      }
    }

    .DateRangePickerInput_clearDates_default:focus,
    .DateRangePickerInput_clearDates_default:hover {
      background: none;

      svg {
        fill: #f2008c;
      }
    }
  }
`;

export const FilterTriggerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const FilterTrigger = styled.div`
  font-weight: 700;
  cursor: pointer;
  text-transform: capitalize;
  display: flex;

  svg.fa-filter {
    margin-right: 10px;
    color: #565656;
    position: relative;
    top: 2px;
    display: ${(props) => props.selected && "none"};
  }
`;

export const FilterTriggerInner = styled.div`
  background-color: ${(props) => props.selected && "#f2008c"};
  color: ${(props) => props.selected && "#fff"};
  padding: 2px 10px;
  font-size: 0.94em;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: relative;
`;

export const FilterOptions = styled.div`
  position: absolute;
  top: 32px;
  cursor: pointer;
  text-align: left;
  box-shadow: rgb(214, 214, 214) 0px 0px 5px;
  opacity: 1;
  z-index: 5;
  left: ${(props) => (props.active ? "5px" : "-150px")};
  opacity: ${(props) => (props.active ? "1" : "0")};
  pointer-events: ${(props) => (props.active ? "auto" : "none")};
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.2s ease-in-out 0s;
  padding: 37.5px 5px 2.5px 5px;

  &::after,
  &::before {
    bottom: 100%;
    left: 40px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #fff;
    border-width: 8px;
    margin-left: 0px;
  }

  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #eaeaea;
    border-width: 10px;
    margin-left: -2px;
  }

  ${mediaMaxWidth.tablet`
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
    padding: 40px 5px 2.5px 5px;
  `}
`;

export const Header = styled.div`
  position: absolute;
  font-size: 0.8em;
  color: #565656;
  top: 5px;
  border-bottom: 1px solid rgb(216, 216, 216);
  display: flex;
  flex: 1;
  width: calc(100% - 20px);
  margin: 0 5px;
  padding: 3px 7.5px;
  font-weight: 600;

  ${mediaMaxWidth.tablet`
    font-size: 1em;
    width: calc(100vw - 20px);
    padding: 5px 7.5px;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.9em;
  `}
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 0.9em;
  top: 6px;
  right: 17.5px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #f2008c;
    }
  }

  ${mediaMaxWidth.tablet`
    top: 6px;
    font-size: 1.4em;
  `}

  ${mediaMaxWidth.smallPhone`
    top: 7px;
    font-size: 1.2em;
  `}
`;

export const FilterOption = styled.div`
  cursor: pointer;
  padding: ${(props) =>
    props.selected ? "5px 35px 5px 10px" : "5px 5px 5px 10px"};
  border-radius: 4px;
  text-transform: capitalize;
  position: relative;
  color: #565656;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
  display: block;
  margin: 2.5px;

  svg {
    position: absolute;
    right: 8px;
    top: 9px;
    font-size: 0.8em;
  }

  &:hover {
    background-color: #f2008c;
    color: #fff;
  }

  ${mediaMaxWidth.tablet`
    font-size: 1.5em;
    width: calc(100vw - 15px);
    padding: ${(props) =>
      props.selected ? "5px 45px 5px 10px" : "5px 10px 5px 10px"};

    &:hover {
      background-color: #fff;
      color: #565656;
    }
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 1.35em;
  `}
`;

export const ResetSingleFilter = styled.div`
  position: relative;
  top: 2px;

  svg.fa-times {
    cursor: pointer;
    z-index: 5;
    background-color: #f2008c;
    padding: 4px 0px;
    height: 25px;
    color: #fff;
    width: 25px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    position: relative;
  }
`;

export const MobileCloseBtn = styled.div`
  position: fixed;
  right: 8px;
  top: 5px;
  text-decoration: underline;
`;
